<template>
	<div class="containerMain" >
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="schoolSummary && categorySummary">
			<title-bar :title="schoolSummary.itemName" :percentage="schoolSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<title-bar :title="categorySummary.categoryName" :percentage="categorySummary.percentage" percentageTitle="Promedio Categoría" :categoryId="categoryId"/>
			<div class="row between innerRubric">
				<percentages-detail v-for="question in categorySummary.questions" :key="question.id" :question="question" :categoryId="categoryId"/>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import mediator from '@/mediator';
export default {
	props: ['categoryId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	data () {
		return {
			items: [
				{
					isActive: true,
					age: 40,
					first_name: 'Dickerson',
					last_name: 'Macdonald'
				},
				{
					isActive: false,
					age: 21,
					first_name: 'Larsen',
					last_name: 'Shaw'
				},
				{
					isActive: false,
					age: 89,
					first_name: 'Geneva',
					last_name: 'Wilson'
				},
				{
					isActive: true,
					age: 38,
					first_name: 'Jami',
					last_name: 'Carney'
				}
			]
		};
	},
	computed: {
		schoolSummary () {
			if (this.$store.state.school.summary) return this.$store.state.school.summary[0];
			else return this.$store.state.school.summary;
		},
		categorySummary () {
			if (!this.$store.state.school.categoriesSummary) return this.$store.state.school.categoriesSummary;
			else return this.$store.state.school.categoriesSummary.find((coachingCategory) => {
				return coachingCategory.id == this.categoryId;
			});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/routes/school/CategorySummary.vue